var theme = {
  bg: '#1a1a2e',
  bgGradient: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
  bgDeep: '#0f0f23',
  bgCard: 'rgba(255,255,255,0.05)',
  bgOverlay: 'rgba(0,0,0,0.7)',
  text: '#e0e0e0',
  textMuted: '#888',
  textDim: '#666',
  textPlaceholder: '#555',
  accent: '#4ade80',
  accentGradient: 'linear-gradient(45deg, #4ade80, #22c55e)',
  accentHover: '#22c55e',
  border: '#333',
  borderLight: '#444',
  success: '#4CAF50',
  error: '#f44336',
  warning: '#FF9800',
  info: '#2196F3',
  breakfast: '#FF9800',
  lunch: '#4ade80',
  dinner: '#6366f1',
  snack: '#ec4899',
  dessert: '#a855f7',
  side: '#22d3ee',
  radius: '12px',
  radiusSm: '8px',
  radiusPill: '24px'
};

export default theme;
